import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import store from "./store/index";
import '@/utils/fetch';
import './assets/css/normalize.scss'
import './assets/css/base.scss'
import '@/assets/icons' // icon图标组件
import apiService from '@/apiList'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import * as echarts from 'echarts';
import {
  downLoadCode, GetToken, toast
} from '@/utils/index'
Vue.use(ElementUI);
Vue.config.productionTip = false;

import dayJs from '@/utils/dayFormat';
Vue.prototype.$api = apiService
Vue.prototype.$dayDto = dayJs
Vue.prototype.$downLoadCode = downLoadCode
Vue.prototype.$toast = toast
Vue.prototype.$echarts = echarts

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

Vue.prototype.downLoadFile = function (config) {
  // 获取时间，这一步是在下载时文件名带下载日期，例如：用户信息2020-04-27.xls,如无需要可以去掉
  let d = new Date()
  let month = (d.getMonth() + 1)
  let day = d.getDate()
  let time = d.getFullYear() + '-' + (String(month).length > 1 ? month : '0' + month) + '-' + (String(day).length > 1 ? day : '0' + day)
  // 地址
  // let baseURL = 'http://fmshopsit.hbunion.com/'  // 域名
  // let baseURL = window.SITE_CONFIG.baseUrl  // 域名
  function createObjectURL (object) { return (window.URL) ? window.URL.createObjectURL(object) : window.webkitURL.createObjectURL(object) }
  let xhr = new XMLHttpRequest()
  let formData = new FormData()
  for (let key in config.data) {
    formData.append(key, config.data[key])
  }
  xhr.open('POST', config.url)
  // xhr.setRequestHeader('token', Vue.cookie.get('token'))
  xhr.responseType = 'blob'
  xhr.onload = function (e) {
    if (this.status === 200) {
      let blob = this.response
      // xls文件名称
      let filename = `${config.fileName}${time}.xlsx`
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename)
      } else {
        let a = document.createElement('a')
        let url = createObjectURL(blob)
        a.href = url
        a.download = filename
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
      }
    }
  }
  xhr.send(formData)
}